import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { debug, browserPerformanceTimeOrigin, timestampInSeconds, getCurrentScope, htmlTreeAsString, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN } from '@sentry/core';
import { DEBUG_BUILD } from '../debug-build.js';
import { addClsInstrumentationHandler } from './instrument.js';
import { supportsWebVital, listenForWebVitalReportEvents, msToSec, startStandaloneWebVitalSpan } from './utils.js';

/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */
function trackClsAsStandaloneSpan(client) {
  var standaloneCLsValue = 0;
  var standaloneClsEntry;
  if (!supportsWebVital('layout-shift')) {
    return;
  }
  var cleanupClsHandler = addClsInstrumentationHandler(function (_ref) {
    var metric = _ref.metric;
    var entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    standaloneCLsValue = metric.value;
    standaloneClsEntry = entry;
  }, true);
  listenForWebVitalReportEvents(client, function (reportEvent, pageloadSpanId) {
    _sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
    cleanupClsHandler();
  });
}

/**
 * Exported only for testing!
 */
function _sendStandaloneClsSpan(clsValue, entry, pageloadSpanId, reportEvent) {
  var _entry$sources$;
  DEBUG_BUILD && debug.log("Sending CLS span (".concat(clsValue, ")"));
  var startTime = entry ? msToSec((browserPerformanceTimeOrigin() || 0) + entry.startTime) : timestampInSeconds();
  var routeName = getCurrentScope().getScopeData().transactionName;
  var name = entry ? htmlTreeAsString((_entry$sources$ = entry.sources[0]) === null || _entry$sources$ === void 0 ? void 0 : _entry$sources$.node) : 'Layout shift';
  var attributes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.http.browser.cls'), SEMANTIC_ATTRIBUTE_SENTRY_OP, 'ui.webvital.cls'), SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, 0), 'sentry.pageload.span_id', pageloadSpanId), 'sentry.report_event', reportEvent);

  // Add CLS sources as span attributes to help with debugging layout shifts
  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
  if (entry !== null && entry !== void 0 && entry.sources) {
    entry.sources.forEach(function (source, index) {
      attributes["cls.source.".concat(index + 1)] = htmlTreeAsString(source.node);
    });
  }
  var span = startStandaloneWebVitalSpan({
    name: name,
    transaction: routeName,
    attributes: attributes,
    startTime: startTime
  });
  if (span) {
    span.addEvent('cls', _defineProperty(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, ''), SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, clsValue));

    // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
    // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
    span.end(startTime);
  }
}
export { _sendStandaloneClsSpan, trackClsAsStandaloneSpan };